import TextSignature from './TextSignature';

export default TextSignature;